<script>
import ItemIndex from "../../abstract/ItemIndex.js";

export default ItemIndex.extend({
  data() {
    return {
      endpoint: "/api/schedule",
      sortColumn: "academic_year",
      sortColumnDirection: "desc",
      messages: {
        remove: {
          title: "Удаление расписания",
          message: "Вы действительно хотите удалить данное расписание?",
          confirm: "Удалить расписание",
          cancel: "Отмена",
          success: "Расписание было успешно удалено"
        }
      },
      options: {
        trashed: false
      }
    };
  },
  methods: {
    mergeOptions: function(options) {
      return _.merge(
        {
          with: ["entries"]
        },
        options
      );
    },
    beforeOpen(item) {
      return new Promise((resolve, reject) => {
        if (item) {
          reject();
          window.open(item.url, "_self");
        } else {
          resolve();
        }
      });
    },
    modified() {
      this.modal.modified = true;
    },
    save() {
      let loading = this.$loading.open();
      this.$refs.form
        .save()
        .then(schedule => {
          window.open(schedule.url, "_self");
        })
        .catch(() => {
          loading.close();
          this.modal.modified = false;
        });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/schedule/Index.vue